module.exports = __webpack_public_path__ + "img/bottom.84ea84c6.png";